import { IntegrationDescription } from "./IntegrationDescription";
import { Navigate, useParams } from "react-router-dom";
import useMediaQuery from "../../utilis/screenWidthUtils";
import {PhoneHQButton, PhoneHQGlyph} from 'ch3-ui-lib';
import google from "../../assets/google.svg";
import pipedrive from "../../assets/pipedrive.svg";
import { IntegrationGoogle } from "./Google/IntegrationGoogle";
import { UserList } from "./Users/UserList";
import {useNavigate} from 'react-router-dom';
import {useSelector} from "react-redux";
import AdminPanelRestrictedView from "../../components/AdminPanelRestrictedView/AdminPanelRestrictedView";
import {RootState} from "../../store/store.ts";
import {useGetIntegrationsQuery} from "../../store/features/integrations/integrationsService";

import {PipdriveAutomation} from "./Pipedrive/PipedriveAutomation.tsx";
import {PipedriveSettings} from "./Pipedrive/PipedriveSettings.tsx";
import {GoogleDisconnected, PipedriveDisconnected} from "./Google/IntegrationDisconnected.tsx";


type IntegrationKey = "google" | "pipedrive";

export interface IntegrationStep {
    integrationName?: string;
    instructionText?: string | JSX.Element;
    buttonLabel?: string;
}
interface IntegrationDescriptionProps extends IntegrationStep {
    google: IntegrationStep;
    pipedrive: IntegrationStep;
}
const syncSteps: IntegrationDescriptionProps = {
    google: {
        integrationName: "Google Workspace",
        buttonLabel: "I've completed all the steps, proceed",
        instructionText: "You can also check detailed instruction in our Knowledge Base Article."
    },
    pipedrive: {
        integrationName: "Pipedrive",
        buttonLabel: "Install now",
        instructionText: <div>You can also check detailed instruction in our."<span className='text-brand-ink'>Knowledge Base Article</span><PhoneHQGlyph name='open_in_new' size={12}/>,</div>
    }
};

export const Integration = () => {

    const { id, step } = useParams<{ id?: IntegrationKey; step?: "info" | "connect" | "list" | "disconnected" | "settings"  }>();
    const isMobile = useMediaQuery("(max-width: 960px)");
    const role = useSelector((state: RootState) => state.auth.role);
    const { data: integrationsData } = useGetIntegrationsQuery();

    const navigate = useNavigate();
    const steps: { pipedrive: { info: JSX.Element, connect: JSX.Element, settings: JSX.Element, disconnected: JSX.Element }; google: { list: JSX.Element; connect: JSX.Element; info: JSX.Element, disconnected: JSX.Element } } = {
        google: {
            info: <IntegrationDescription {...syncSteps["google"]} />,
            connect: <IntegrationGoogle />,
            list: <UserList />,
            disconnected: <GoogleDisconnected />
        },
        pipedrive: {
            info: <IntegrationDescription {...syncSteps["pipedrive"]} />,
            connect: <PipdriveAutomation />,
            settings: <PipedriveSettings />,
            disconnected: <PipedriveDisconnected />

        }
    };

    const currentId = id ?? "google";
    const currentStep = step ?? "info";
    const installedPipedrive = currentId === "pipedrive" && currentStep === "info"
        ? (Array.isArray(integrationsData?.data) ? integrationsData.data : [])
            .find((integration: {id: number; platform: string; details?: {disabled?: boolean}}) => integration.platform === "PIPEDRIVE" && !integration.details?.disabled)
        : undefined;

    if (installedPipedrive) {
        return <Navigate to={`/admin/integrations/pipedrive/settings?id=${installedPipedrive.id}`} replace />;
    }

    return (

        <div className={`w-full `}>
            {Boolean(role === 'ADMIN' || role === 'SUPERADMIN') &&
            <>

            <div className="flex gap-4 items-center z-40 relative pt-8 px-8 w-[30%]"  onClick={() => navigate('/admin/integrations')}>
                {/* {currentId == 'google' && <img src={google} alt="Google Logo"/>} */}
                <PhoneHQButton variant="secondary" size="sm" className="pl-1" phq-id={`${syncSteps[currentId].integrationName}-backToIntegrationListBtn`}><PhoneHQGlyph name="arrow_back_ios" size={16}/></PhoneHQButton>
                {currentId === 'google' && <img src={google} alt="Google Logo"/>}
                {currentId === 'pipedrive' && <img src={pipedrive} alt="Pipedrive Logo"/>}

                <div className={"font-bold text-xl"}>{syncSteps[currentId].integrationName}</div>
            </div>
            <div
                className={
                    ` px-8 pb-10  ` +
                    `${isMobile ? "px-4 flex-col" :  " flex-row" } ` +
                    "  gap-8 items-start "
                }
            >
                {steps[currentId]?.[currentStep as keyof typeof steps[typeof currentId]]}
            </div>
            </>
            }
             {
            Boolean(role === 'USER') &&
                <AdminPanelRestrictedView></AdminPanelRestrictedView>
            }
        </div>
    );
};
